import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from '../Common/store/rootReducer';
import { AppView } from '../Common/types/AppConfigTypes';
import * as appConfigActions from '../AppConfig/appConfigActions';
import { appViewSelector } from '../AppConfig/appConfigSelectors';
import ListView from '../List/components/ListView/ListView';
import ComparisonView from '../Comparison/components/ComparisonView/ComparisonView';

const mapStateToProps = (state: RootState) => ({
    appView: appViewSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            initializeApp: appConfigActions.initializeApp,
        },
        dispatch,
    );

type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const AppViewContainer: React.FC<Props> = ({ appView, initializeApp }) => {
    useEffect(() => {
        initializeApp();
    }, [initializeApp]);

    if (appView === AppView.List) {
        return <ListView />;
    }
    if (appView === AppView.Comparison) {
        return <ComparisonView />;
    }
    return <h1>View Not Found</h1>;
};

export default connect(mapStateToProps, mapDispatchToProps)(AppViewContainer);
